import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import permessi from "@/config/permessi";
import { TextValueItem } from "@/models/TextValueItem";
import api from "@/services/api";
import { Component, Prop } from "vue-property-decorator";
import { GruppiNazionalitaPerFornitore } from "../../../models/anafrafica/gruppiNazionalitaPerFornitore";

const _ENDPONT = api.endpoint.FORNITORI_GRUPPINAZIONALITAFORNITORE;
@Component
export default class GruppiNazionalitaFornitori extends gridComponentBase {
	get PERMESSI(): string[] { return [permessi.BK.Anagrafica.FORNITORI]; }
	@Prop({ default: () => null }) fornitoreID: number;
	@Prop({ default: () => null }) prodottoID: number;
	@Prop({ default: () => false }) readonly: boolean;

	gruppiNazionalita: TextValueItem[] = [];

	editItem: GruppiNazionalitaPerFornitore = new GruppiNazionalitaPerFornitore();
	showEditModal: boolean = false;
	editSubTitle: string = "";
	editTitle: string = "";

	keyIndex:number = 0;

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, editHide: true },

			//{ field: "fornitoreID", title: "FornitoreID", hidden: true, values: this.fornitoreID, editHide: true },
			{
				field: "gruppoNazionalitaID",
				title: this.prodottoID ? this.$i18n.t("generico.gruppoNazionalitaFornitore").toString() : this.$i18n.t("generico.grupponazionalita").toString(),
				sortBy: "gruppoNazionalita",
				headerCell: "myHeaderCellTemplate",
				editSourceValue: "value",
				values: this.gruppiNazionalita,
				filterable: true,
				itemsForFilter: this.gruppiNazionalita,
				filterType: "select",
				editType: "select",
				editSource: this.gruppiNazionalita,
				hidden:true
			},
			// {
			// 	field: "gruppoStatoA3",
			// 	title: "AlphaCode3",
			// 	editHide: true,
			// 	headerCell: "myHeaderCellTemplate",
			// 	filterable: true,
			// },
			{ field: "gruppoNazionalita", title: this.prodottoID ? this.$i18n.t("generico.gruppoNazionalitaFornitore").toString() : this.$i18n.t("generico.grupponazionalita").toString(), editHide: true, headerCell: "myHeaderCellTemplate", filterable: true },
			{ field: "codiceRiepilogo", title: this.$i18n.t("generico.codiceRiepilogo").toString(), headerCell: "myHeaderCellTemplate", width: this.setColPercent(20), filterable: true },
			{ field: "descrizioneRiepilogo", title: this.$i18n.t("generico.descrizioneRiepilogo").toString(), headerCell: "myHeaderCellTemplate", width: this.setColPercent(25), filterable: true },
			// {
			// 	field: "comprendeTuttiGliStati",
			// 	title: this.$i18n.t("generico.tuttiGliStati").toString(),
			// 	headerCell: "myHeaderCellTemplate",
			// 	export: true,
			// 	type: "boolean",
			// 	filterType: "boolean",
			// 	width: 200,
			// 	disabled: true,
			// 	editHide:true
			// },
			
			{ field: "_actions", title: " ", hidden: this.prodottoID ? true: false, width: (50 + (this.canDelete ? 50 : 0)), cell: "defaultCellTemplate", type: "actions_list", filterable: false, headerCell: "myHeaderCellTemplate" }
		];
	}

	created() {
		var self = this;
		Promise.all([api.getDatiDropDown(api.endpoint.DROPDOWN.GRUPPINAZIONALITA).then(res => self.gruppiNazionalita = res)])
			.then(responses => {
				self.getData();
			})
			.catch(err => {
				console.log(err);
			});
	}

	getData() {
		var self = this;
		self.getGridData(`${_ENDPONT}/${this.fornitoreID}`);
	}

	onDelete(item: GruppiNazionalitaPerFornitore) {
		var self = this;
		var itemToDelete = /*item.gruppoStatoA3 + " - " +*/ item.gruppoNazionalita + " - " + item.descrizioneRiepilogo;
		var message = self.$createElement("div", { domProps: { innerHTML: `<h5>${itemToDelete}</h5>${self.$i18n.t("messaggio.confermaCancellazione")}` } }); // h('div', { domProps: { innerHTML: 'Title from <i>HTML<i> string' } })
		var title = this.$i18n.t("titolo.elimina", [this.$i18n.t("generico.grupponazionalita")]).toString();
		self.deleteGridRow(_ENDPONT.replace("/{id}", ""), item.itemID, title, [message]);
	}

	addNewRow() {
		let newItem = new GruppiNazionalitaPerFornitore();
		newItem.fornitoreID = this.fornitoreID;
		if (this.gruppiNazionalita && this.gruppiNazionalita.length > 0) {
			newItem.gruppoNazionalitaID = this.gruppiNazionalita[0].value as number;
		}
		this.onEdit(newItem);
	}

	onEdit(item: any) {
		var self = this;
		self.editItem = Object.assign(new GruppiNazionalitaPerFornitore(), item);
		self.editSubTitle = item.gruppoNazionalita;
		// self.editTitle = item.partitaIva || item.codiceFiscale;
		self.showEditModal = true;
	}

	onSaveEdit() {
		var self = this;
		var title = this.$i18n.t("msg.salvataggioRiuscito").toString();
		var message = this.$i18n.tc("msg.salvato_iCorrettamente", 1, { obj: this.$i18n.t("generico.grupponazionalita") }).toString();
		self.setGridRow<GruppiNazionalitaPerFornitore>(_ENDPONT, self.editItem, title, message, self.isNewItem).then(res => {
			self.showEditModal = false
		});
	}

	
	onReloadAssociaNazionalita() {
		this.keyIndex++;
	}

	get isNewItem(): boolean {
		return (this.editItem || {}).itemID == null || (this.editItem || {}).itemID <= 0;
	}
}
